// Vendors
import { useEffect, useRef } from 'react';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Event Handlers
import { KycBizumHandlers } from '../handlers/kyc-bizum.handlers';
import { KycBizumSocketHandlers } from '../handlers/kyc-bizum-socket.handlers';
// Hooks
import { useWebsocketHook } from 'hooks/websocket.hook';

const useKycBizumHook = (): void => {
  const { setCurrentState } = useAppContextConsumerHook(),
    { setError } = useFetchErrorContextConsumerHook(),
    { setMainButtonConfiguration } = useLayoutContextConsumerHook();
  const timeoutRef = useRef<number>(0);

  const {
    handleOnErrorKycBizumWsMessage,
    handleOnReceiveKycBizumWsMessage,
    handleResetButtonOnEnterView,
  } = KycBizumHandlers({ setCurrentState, setError, setMainButtonConfiguration });

  const {
    handleConnectWebSocketChannelEvent,
    handleDisconnectWebSocketFromChannelEvent,
    handleSendWebSocketMessageEvent,
    websocketConnected,
  } = useWebsocketHook();

  const { handleSendMessageWhenWebSockedLoadedEvent, handleStartWhenSockedLoadedEvent } =
    KycBizumSocketHandlers({
      handleConnectWebSocketChannelEvent,
      handleDisconnectWebSocketFromChannelEvent,
      handleSendWebSocketMessageEvent,
      setError,
      timeoutRef,
      websocketConnected,
      onError: handleOnErrorKycBizumWsMessage,
      onReceiveData: handleOnReceiveKycBizumWsMessage,
    });

  useEffect(() => {
    handleResetButtonOnEnterView();
    const finalizer = handleStartWhenSockedLoadedEvent();
    return () => {
      finalizer?.();
    };
  }, []);

  useEffect(() => {
    handleSendMessageWhenWebSockedLoadedEvent();
  }, [websocketConnected]);
};

export { useKycBizumHook };
